import './App.scss';
import { BrowserRouter as Router, Routes, Route, useLocation, Navigate, useNavigate } from 'react-router-dom';
import { ILocation } from 'models/RouteInterface';

//Pages
import Home from './pages/public/Home/Home';
import PrivateHome from './pages/private/PrivateHome/PrivateHome';
import { RegisterUserFlow } from './pages/public/RegistroUser/RegisterUserFlow';
import { LoginFlow } from './pages/public/Login/LoginFlow';
import { OnBoardingFlow } from './pages/private/OnBoarding/OnBoardingFlow';
import { RecoverPasswordFlow } from 'pages/public/RecoverPassword/RecoverPasswordFlow';
import { PersonalDataProfile } from './pages/private/PersonalData/PersonalDataProfile';
import ContactComponent from 'pages/public/TestComponents/Contact/ContactComponent';
import NewsletterComponent from 'pages/public/TestComponents/Contact/NewsLetterComponent';
import TranslationComponent from 'pages/public/TestComponents/Contact/TranslationComponent';
import { DeleteAccountFlow } from './pages/private/DeleteAccount/DeleteAccountFlow';
import { Preferences } from './pages/private/Preferences/Preferences';
import { PlannerFlow } from 'pages/public/Planner/PlannerFlow';
import TripSelector from "./pages/private/TripSelector/TripSelector";
import TripSelectorTrain from 'pages/private/TripSelectorTrain/TripSelectorTrain';
import { PaymentMethodsFlow } from "./pages/private/PaymentMethods/PaymentMethods";
import { ResumeRoute } from "./pages/private/ResumeRoute/ResumeRoute";
import { MyTrips } from 'pages/private/MyTrips/MyTrips';
import { ResponseOK } from "pages/redsys/responseOK/responseOK";
import { ResponseKO } from "pages/redsys/responseKO/responseKO";
import { RedsysForm } from "pages/redsys/redsysForm/redsysForm";
import { TmbDetailActivity } from "pages/public/TmbDetailActivity/TmbDetailActivity";

//Components
import Assist from 'components/AssistComponent/Assist';
import Header from 'components/HeaderComponent/Header';
import Breadcrumb from 'components/Breadcrumb/Breadcrumb';

//Hooks
import useSession from "hooks/useSession";
import { MyPastTrips } from 'pages/private/MyPastTrips/MyPastTrips';
import { AveFlow } from 'pages/private/AveFlow/AveFlow';
import ConfirmPlani from 'pages/private/ConfirmPlani/ConfirmPlani';
import { OnBoardingFlowATC } from 'pages/private/OnBoardingATC/OnBoardingFlowATC';
import { RegisterUserFlowATC } from 'pages/public/RegistroUserATC/RegisterUserFlowATC';
import useWindowSize from 'hooks/useWindowSize';
import { SmallView } from './pages/public/SmallView/SmallView';
import { TypographyPage } from 'pages/public/TestComponents/Contact/Typography';

import './App.scss';
import { ComponentsView } from 'pages/public/TestComponents/Contact/ComponentsView';


import pkg from "./../package.json";
import { ReturnFromToAve } from 'pages/private/ReturnFromToAve/ReturnFromToAve';

// Amplify (Login social)
import { useEffect } from 'react';
import { fetchCognitoUserStatus, getUser, initUser, saveSessions } from 'services/user/user-login-social.service';

import { Amplify, Hub } from 'aws-amplify';
import awsExports from './aws-exports';
import { isEmptyObject } from 'services/util/util.service';
import { checkLoggedSocialStorage, getCurrentRedirection, IUserData, RaaSSession, SessionStorageItems, setStorage } from 'services/user/user.session.service';
import { removeItemStorage } from 'services/util/sessionStorage.service';
import { MyCardsTitles } from 'pages/private/MyCardsTitles/MyCardsTitles';
import { MyCardsRenfe } from 'pages/private/MyCardsRenfe/MyCardsRenfe';
import { MyCardsFamily } from 'pages/private/MyCardsFamily/MyCardsFamily';
import { TmbNightBusFlow } from 'pages/public/TmbNightBusFlow/TmbNightBusFlow';
import { TmbNormalFlow } from 'pages/public/TmbNormalFlow/TmbNormalFlow';
import { TmbResumeRoute } from 'pages/private/TmbResumeRoute/TmbResumeRoute';
import TmbConfirmPlanni from 'pages/private/TmbConfirmPlanni/TmbConfirmPlanni';
import { SixtFlow } from 'pages/private/SixtFlow/SixtFlow';
import { RecoglobickActivitiesMmb } from 'pages/public/Globick/RecoglobickActivitiesMmb';
import { ResponseOkGlobick } from 'pages/redsys/responseOK/responseOkGlobick';
import { TrainFlowPlanner } from 'pages/public/TrainPlanner/TrainFlowPlanner';
import ActivityConfirmPlanni from 'pages/private/ActivityConfirmPlanni/ActivityConfirmPlanni';
import { MyPoints } from 'pages/private/MyPoints/MyPoints';
import { ResponseCITMono } from 'pages/redsys/responseCIT/responseCITMono';
import { MyDocuments } from 'pages/private/MyDocuments/MyDocuments';
import { QRVeridas } from 'pages/private/QRVeridas/QRVeridas';
import { Permissions } from 'pages/private/Permissions/Permissions';




Amplify.configure(awsExports);

function getVersion() {
  const saved = sessionStorage.getItem('raas-version');
  if (!!!saved && pkg?.version) {
    console.log('Versión', pkg?.version);
    sessionStorage.setItem('raas-version', pkg.version);
  }
}

function App() {

  const { logged, loggedSocial, loadingRedirectBySocial, setSession, setLogged, setLoggedSocial, setLoadingRedirectBySocial, setUserConnected } = useSession();
  const location = useLocation();
  const { isXSView } = useWindowSize();

  useEffect(() => {
    const unsubscribe = Hub.listen("auth", ({ payload: { event, data } }: any) => {
      switch (event) {
        case 'cognitoHostedUI':
          initLoginSocial();
          break;
        case 'oAuthSignOut':
          localStorage.removeItem('amplify-signin-with-hostedUI');
          localStorage.removeItem('amplify-redirected-from-hosted-ui');
          setSession({} as RaaSSession);
          setUserConnected({} as IUserData);
          removeItemStorage(SessionStorageItems.RAAS_USER);
          removeItemStorage(SessionStorageItems.RAAS_USER_DETAIL);
          setStorage();
          break;
      }
    });
    checkLoggedSocialStorage() && loggedSocial && initLoginSocial();
    return unsubscribe;
  }, []);


  const initLoginSocial = async () => {
    const logged = await fetchCognitoUserStatus();
    if (logged) {
      if (document.body.style?.overflow === 'hidden') document.body.style.overflow = "auto";
      getLoginSocial();
    } else {
      setLoadingRedirectBySocial(false);
    }
  }
  const getLoginSocial = async () => {
    const user = await getUser()
    if (user && !isEmptyObject(user)) {
      const signInUserSession: RaaSSession = saveSessions(user) as RaaSSession;
      if (!!signInUserSession?.sessionToken) {
        setSession(signInUserSession);
        setStorage(signInUserSession);
        setLogged(true);
        setLoggedSocial(true);
      }
    }
    setLoadingRedirectBySocial(false);
  }

  getVersion();


  return (
    <div className="App">
      {
        loadingRedirectBySocial && !loggedSocial ? <>.</> : <Pages />
      }
    </div>
  );

}

function Pages() {

  const location = useLocation();
  const { isXSView } = useWindowSize();
  const { logged, loggedSocial } = useSession();

  const currentPage: string = getCurrentRedirection();

  if (window.location.hostname.includes('localhost') && !document.title.includes('local')) {
    const title = document.title;
    document.title = `${title} local`;
  }

  return (
    <>
      <Header location={location as ILocation}></Header>
      <Breadcrumb location={location as ILocation}></Breadcrumb>
      <Routes>
        {
          /*   !isXSView ? */
          <>
            {/* Public routes */}
            <Route path='/' element={loggedSocial ?
              /* CUANDO ESTAMOS LOGADOS POR LOGIN SOCIAL, NOS REDIRIGIMOS A LA PANTALLA MY PROFILE */
              (<Navigate replace to={currentPage || "/my-profile"} />)
              :
              /* CUANDO ESTAMOS LOGADOS POR LOGIN NORMAL, NOS REDIRIGIMOS A LA PLANIFICACIÓN */
              (
                logged ?
                  (<Navigate replace to="/plan" />)
                  :
                  /* CUANDO ESTAMOS NO LOGADOS, MOSTRAMOS LA HOME PÚBLICA (si no hay redireccion) */
                  (<Home />)
              )
            } />
            <Route path='/login' element={logged ?
              /* CUANDO ESTAMOS LOGADOS, NOS REDIRIGIMOS A LA PANTALLA MY PROFILE */
              (<Navigate replace to="/plan" />)
              :
              /* CUANDO ESTAMOS NO LOGADOS, MOSTRAMOS LA HOME PÚBLICA */
              (<LoginFlow />)
            } />
            <Route path='/register-user' element={<RegisterUserFlow />} />
            <Route path='/register-user-ATC' element={<RegisterUserFlowATC />} />
            {/* <Route path='/login' element={<LoginFlow />} /> */}
            <Route path='/plan' element={<PlannerFlow />} />
            <Route path='/return-ave' element={<ReturnFromToAve />} />
            <Route path='/trip' element={<TripSelector />} />
            <Route path='/trip-train' element={<TripSelectorTrain />} />
            <Route path='/my-trips' element={<MyTrips />} />
            <Route path='/detail-activy' element={<TmbDetailActivity />} />
            {/* <Route path='/sixt-flow' element={<SixtFlow />} /> */}
            <Route path='/activity-management' element={<RecoglobickActivitiesMmb />} />
            <Route path='/tmb-night-bus-flow' element={<TmbNightBusFlow />} />
            <Route path='/tmb-normal-flow' element={<TmbNormalFlow />} />
            <Route path='/urlOK' element={<ResponseOkGlobick />} />
            <Route path='/planTrain' element={<TrainFlowPlanner />} />
            <Route path='/urlOK:action' element={<ResponseOkGlobick />} />
            <Route path='/urlKO' element={<ResponseKO />} />
            <Route path='/QRVeridas' element={<QRVeridas />} />

          </>
          /* :*/
          /* Si es una pantalla móvil con menos de 360px de resolución */
          // <Route path='*' element={<SmallView />} />

        }

        <Route path='/reset-password' element={<RecoverPasswordFlow />} />

        {/* Test routes */}
        <Route path='/test/contact-form' element={<ContactComponent />} />
        <Route path='/test/newsletter' element={<NewsletterComponent />} />
        <Route path='/test/translation' element={<TranslationComponent />} />
        <Route path='/test/typography' element={<TypographyPage />} />
        <Route path='/test/components' element={<ComponentsView />} />
        <Route path='/test/resume' element={<ResumeRoute />} />
        <Route path='/trial-login-social' element={<ComponentsView />} />
        {/* <Route path='/test/map' element={<Map />} /> */}




        {/* Private routes */}
        {logged ?
          /* CUANDO ESTAMOS LOGADOS */
          (
            <>
              {
                // !isXSView ?
                <>
                  <Route path='/my-profile' element={<PrivateHome />} />
                  <Route path='/on-boarding' element={<OnBoardingFlow />} />
                  <Route path='/on-boarding-ATC' element={<OnBoardingFlowATC />} />
                  <Route path='/personal-data' element={<PersonalDataProfile />} />
                  <Route path='/delete-account' element={<DeleteAccountFlow />} />
                  <Route path='/my-preferences' element={<Preferences />} />
                  <Route path='/ave-stepper-page' element={<AveFlow />} />
                  <Route path='/resume-route' element={<ResumeRoute />} />
                  <Route path='/my-trips' element={<MyTrips />} />
                  <Route path='/payment-methods' element={<PaymentMethodsFlow />} />
                  <Route path='/my-past-trips' element={<MyPastTrips />} />
                  <Route path='/redsys-ok' element={<ResponseOK />} />
                  <Route path='/redsys-ko' element={<ResponseKO />} />
                  <Route path='/redsys:action' element={<RedsysForm />} />
                  <Route path='/confirm-planing' element={<ConfirmPlani />} />
                  {/* <Route path='/cards-titles' element={<MyCardsTitles />} />
                  <Route path='/cards-renfe' element={<MyCardsRenfe />} />
                  <Route path='/cards-family' element={<MyCardsFamily />} /> */}
                  <Route path='/tmb-resume-route' element={<TmbResumeRoute />} />
                  <Route path='/tmb-confirm-planning' element={<TmbConfirmPlanni />} />
                  <Route path='/activity-confirm-planning' element={<ActivityConfirmPlanni />} />
                  {/* <Route path='/my-points' element={<MyPoints />} /> */}
                  <Route path="/confirmation" element={<ResponseCITMono />} />
                  <Route path='/my-documents' element={<MyDocuments />} />
                  <Route path='/permissions' element={<Permissions />} />



                </>
                /*:
               /* Si es una pantalla móvil con menos de 360px de resolución */
                // <Route path='*' element={<SmallView />} />
              }
            </>
          )
          :/* CUANDO NO ESTAMOS LOGADOS, NOS SALIMOS DE LAS RUTAS PRIVADAS Y NAVEGAMOS A LA HOME PÚBLICA */
          (
            <Route path='*' element={!logged && (<Navigate replace to="/" />)} />
          )}

      </Routes>
    </>

  );
}

export default App;
